import { useContent } from "@/content/ContentProvider";
import React from "react";
import { ArrowDown, Check, Layers } from "lucide-react";

// An illustrative process diagram, never presented as a product screenshot or client result.
export default function WorkflowDiagram({ steps = null, className = "" }) {
  const { text: cmsText, DEFAULT_WORKFLOW } = useContent();
  steps = steps || DEFAULT_WORKFLOW;
  return (
    <div
      className={`relative flex h-full w-full flex-col justify-center overflow-hidden bg-[#efefed] p-5 sm:p-8 ${className}`}
    >
      <div className="mb-5 flex items-center justify-between text-[10px] uppercase tracking-[0.08em] text-black/45">
        <span>
          {cmsText(
            "WorkflowDiagram.WorkflowDiagram.illustrative-workflow.6026b0",
          )}
        </span>
        <Layers size={14} aria-hidden="true" />
      </div>
      <div className="mx-auto w-full max-w-[420px]">
        {steps.map((step, i) => (
          <React.Fragment key={step}>
            {i > 0 && (
              <div className="flex justify-center py-1.5 text-black/30">
                <ArrowDown size={16} aria-hidden="true" />
              </div>
            )}
            <div
              className={`flex items-center justify-between gap-3 rounded-[16px] px-5 py-3 ${i === 1 ? "bg-black text-white" : "bg-white text-black"}`}
            >
              <div className="min-w-0">
                <span className="block text-[10px] opacity-40">0{i + 1}</span>
                <p className="mt-1 text-[16px] leading-[1.2] tracking-[-0.02em] sm:text-[20px]">
                  {step}
                </p>
              </div>
              <Check
                size={14}
                aria-hidden="true"
                className="shrink-0 opacity-40"
              />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
